import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { Colors } from '../../../../utils/colors/colors';
import ButtonComponent from '../../../../utils/button/ButtonComponent';
import { redirectToResetLinkSent } from '../../../../reducers';
import authService from '../../../../services/auth.service';










const FormContainer = styled.div`
  width: 90%;

  @media (min-width: 1024px) {
    width: 70%;
  }
`;

const FormContent = styled.div`

`;

export default function Right() {
  const [authError, setAuthError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [otherError, setOtherError] = useState("");


  const { register, formState: { errors }, handleSubmit } = useForm();


  const onSubmit = async (data) => {
    // console.log(data);
    setIsLoading(true);


    try {
      await authService.forgotPassword(data.email).then(
        () => {
          const userEmail = data.email;
          redirectToResetLinkSent(userEmail);
        },
        (error) => {
          console.error(error);
          setOtherError(error?.message);
          setAuthError(error?.response.data.error);
          setIsLoading(false);
        }
      );

    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    otherError && setIsLoading(false);
  }, [otherError]);



  const {
    lightGrayColor,
    whiteColor,
    primaryColor,
  } = Colors();


  return (
    <FormContainer
      style={{}}
    >
      <FormContent
        style={{
          backgroundColor: whiteColor,
          width: "100%",
          padding: "1rem",
          paddingTop: "0"
        }}
      >

        <Form>
          <Form.Group className="mb-3" controlId="formBasicEmail">


            <Form.Label
              style={{
                margin: "12px auto",
                color: lightGrayColor,
              }}
            >
              Email
            </Form.Label>

            <Form.Control
              className={`${errors.email ? 'input-error' : ''}`}
              name="email"
              {...register("email", { required: "Please enter your email" })}
              type="email"
              autoComplete="off"
              placeholder="Enter your email"
              style={{
                backgroundColor: whiteColor,
                padding: "12px 28px",
              }}
            />

            {errors.email && (
              <p className="errorMsg">{errors.email.message}</p>
            )}

          </Form.Group>
        </Form>


        {authError &&
          (<p
            className="errorMsg"
          >
            Error occurred: {" "}
            {authError}
          </p>
          )
        }

        {otherError &&
          (<p
            className="errorMsg"
          >
            Error occurred: {" "}
            {otherError}
          </p>
          )
        }


        <ButtonComponent
          bgColor={primaryColor}
          text={!isLoading ? "Submit" : "Submitting ..."}
          style={{
            minWidth: "100%",
            margin: "2.125rem auto 1rem auto",
          }}
          click={handleSubmit(onSubmit)}
          isLoading={isLoading}
        />

      </FormContent>
    </FormContainer>
  )
}